// extracted by mini-css-extract-plugin
export default {"wrapper":"DensityPlot_wrapper__x8Zqm"};